import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs/Observable'; 
import { Location } from '@angular/common';
import { NgPipesModule } from 'ngx-pipes';
import { LoaderService } from '../../../../services/loader.service';
import { CategoryService} from '../category.service';
declare var $:any;

@Component({
  selector: 'app-vendor',
  templateUrl: './vendor.component.html',
  styleUrls: ['./vendor.component.css'],
  providers: [CategoryService]
})
export class VendorComponent implements OnInit {
  vendorForm:FormGroup;
  vendorUpdateForm:FormGroup;
  errorMessage : string;
  erroralert = false;
  successalert = false;
  successMessage : string;
  showvalidationMsg : boolean;
  showvalidEmaliMsg : boolean;
  showvalidMobileNo : boolean;

  constructor(
    private router: Router,
    private loaderService : LoaderService,
    private categoryService:CategoryService,
    private formBuilder: FormBuilder,
    private location: Location

    ) { 



    this.vendorForm = this.formBuilder.group({

      name : new FormControl("",Validators.required),
      pan_no : new FormControl("",[Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]),
      address : new FormControl("",Validators.required),
      contact_person : new FormControl("",Validators.required),
      contact_number : new FormControl("",[Validators.pattern(/^[6789]\d{9}$/)]),
      email : new FormControl("",[Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      gst_reg_no : new FormControl("",Validators.required),
      account_holder : new FormControl("",Validators.required),
      account_number : new FormControl("",Validators.required),
      bank_name : new FormControl("",Validators.required),
      branch_name : new FormControl("",Validators.required),
      ifsc_code : new FormControl("",Validators.required),
      pan_copy : new FormControl("",Validators.required),
      gst_copy : new FormControl("",Validators.required),
      cancelled_cheque : new FormControl("",Validators.required),     
      city : new FormControl("",Validators.required),
      category_ids : new FormControl("",Validators.required),
      sub_category_ids : new FormArray([],Validators.required),
      serviceable_city_ids : new FormArray([],Validators.required),
    })

  }

  itemList =[];
  ngOnInit( ) {
    this.vendorUpdateForm = this.formBuilder.group({

      name : new FormControl("",Validators.required),
      pan_no : new FormControl("",[Validators.pattern(/^([a-zA-Z]){5}([0-9]){4}([a-zA-Z]){1}?$/)]),
      address : new FormControl("",Validators.required),
      contact_person : new FormControl("",Validators.required),
      contact_number : new FormControl("",[Validators.pattern(/^[6789]\d{9}$/)]),
      email : new FormControl("",[Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]),
      gst_reg_no : new FormControl("",Validators.required),
      account_holder : new FormControl("",Validators.required),
      account_number : new FormControl("",Validators.required),
      bank_name : new FormControl("",Validators.required),
      branch_name : new FormControl("",Validators.required),
      ifsc_code : new FormControl(""),
      pan_copy : new FormControl(""),
      gst_copy : new FormControl(""),
      cancelled_cheque : new FormControl("",Validators.required),     
      city : new FormControl("",Validators.required),
      category_ids : new FormControl("",Validators.required),
      sub_category_ids : new FormArray([],Validators.required),
      serviceable_city_ids : new FormArray([],Validators.required),
    })


    this.getVendorCategories();
    this.getFilterData();
    this.getVendorList();

  }
  headers_res;
  per_page;
  total_page;
  current_page;
  getVendorList(page?,search?){

    this.categoryService.getVendorList(page,search).subscribe(
      res=>{
        this.headers_res= res.headers._headers;
        this.per_page = this.headers_res.get('x-per-page');
        this.total_page = this.headers_res.get('x-total');
        this.current_page = this.headers_res.get('x-page');

        res= res.json();
        this.itemList = res['vendors'];
        this.loaderService.display(false);
      },
      err=>{
           console.log(err);
           this.loaderService.display(false);
      });
  }
  dropdownCityList = [];
  selectedServicableCity = [];
  dropdownSscSettings = {
    singleSelection: false,
    text: "Select city",
    selectAllText:'Select All',
    unSelectAllText:'UnSelect All',
    enableSearchFilter: true,
    classes:"myclass custom-class-dropdown",
  };
  city_list = [];
  getFilterData(){
    this.categoryService.getCities().subscribe(
       res=>{
        this.city_list = res['cities'];
        for(var i =0;i< res.cities.length;i++){
          var obj ={
            "id":res.cities[i].id,"itemName":res.cities[i].name.replace("_"," ").toLowerCase().split(' ').map(x=>x[0].toUpperCase()+x.slice(1)).join(' ')
          }
          this.dropdownCityList.push(obj);
          
        }
       },
       err=>{
      console.log(err)
       }
       );
  }

  categories;
  getVendorCategories(){
    this.categoryService.getVendorCategories().subscribe(
      res=>{
          this.categories = res['vendor_categories'];
      },
      err=>{
         console.log(err);
      }
      );
  }
  selectedSet='first';
  getSet(value){
   this.selectedSet = value;
  }
  subId;
  selected_category_id:any = "";
  selected_category_name:any = "";
  getSubCategories(event){
    this.selected_category_id = event.target.value
    this.selected_category_name = event.target.options[event.target.selectedIndex].text
    this.subId = event.target.value;
    this.getSubCategoriesValues(this.subId);
  }
  subCategoryList;
  getSubCategoriesValues(value){
    this.categoryService.getSubcategoryList(value).subscribe(res=>
      { 
        this.subCategoryList = res['vendor_categories']
      },
      err=>{
           console.log(err);
      }
      );

  }
  onSscItemSelect(item: any) {
    console.log(item);

    console.log(this.selectedServicableCity);
  }

  OnSscItemDeSelect(item: any) {
    console.log(item);
    console.log(this.selectedServicableCity);
  }

  onSscSelectAll(items: any) {
    console.log(items);
  }

  onSscDeSelectAll(items: any) {
    console.log(items);
  }

  onSscCheckChange(event){
    if(event.target.checked){
      (<FormArray>this.vendorForm.controls['serviceable_city_ids']).push(new FormControl(event.target.value));
    } else{
      var j:number = 0;
      (<FormArray>this.vendorForm.controls['serviceable_city_ids']).controls.forEach((ctr: FormControl) => {
        if(ctr.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          (<FormArray>this.vendorForm.controls['serviceable_city_ids']).removeAt(j);
          return;
        }

        j++;
      });
    }
  }
  pan_copy_image: any;
  gst_copy_image:any;
  cheque_copy_image:any;
  basefile_pan: any;
  basefile_gst:any;
  basefile_cheque:any;

  onChange(event,i) {
    this.pan_copy_image = event.srcElement.files[0];
    
    var fileReader = new FileReader();

    var base64;
    fileReader.onload = (fileLoadedEvent) => {
       base64 = fileLoadedEvent.target;
      this.basefile_pan = base64.result
    };
    fileReader.readAsDataURL(this.pan_copy_image);
  } 

  gst_copy:any;
  onChange1(event,i) {
    this.gst_copy_image = event.srcElement.files[0];
    
    var fileReader = new FileReader();

    var base64;
    fileReader.onload = (fileLoadedEvent) => {
       base64 = fileLoadedEvent.target;
      this.basefile_gst = base64.result
    };
    fileReader.readAsDataURL(this.gst_copy_image);
  }

  cancelled_cheque:any;
  onChange2(event,i) {
    this.cheque_copy_image = event.srcElement.files[0];
    
    var fileReader = new FileReader();

    var base64;
    fileReader.onload = (fileLoadedEvent) => {
       base64 = fileLoadedEvent.target;
      this.basefile_cheque = base64.result
    };
    fileReader.readAsDataURL(this.cheque_copy_image);
  }

  selected_subcategory_id:any = "";
  selected_subcategory_name:any = "";
  setCurrentSubCategory(event){
    this.selected_subcategory_id = event.target.value;
    this.selected_subcategory_name = event.target.options[event.target.selectedIndex].text;

  }
  onFocusFunction(id) {
 

    if( id == 'contact') {
      this.showvalidMobileNo = false;
      document.getElementById("contact").classList.remove('field_with_errors');
    }
  }

  selected_cate_subcate_list:any = [];
  AddSubCategories(record = 'new'){
    let obj = {
      "category_id": this.selected_category_id,
      "category_name": this.selected_category_name,
      "subcategory_id": this.selected_subcategory_id,
      "subcategory_name": this.selected_subcategory_name,
    }
    
    if(record == 'new'){
      this.selected_cate_subcate_list.push(obj);
      (<FormArray>this.vendorForm.controls['sub_category_ids']).push(new FormControl(this.selected_subcategory_id));
    }
    else{
      this.selected_cate_subcate_list_update.push(obj);
      (<FormArray>this.vendorUpdateForm.controls['sub_category_ids']).push(new FormControl(this.selected_subcategory_id));
    }
    // var formelem = <FormArray>this.vendorForm.controls['sub_category_ids']);
    // formelem.splice(formelem.indexOf(this.selected_subcategory_id),1)
  }



    onCheckChange(event){
      if(event.target.checked){
        (<FormArray>this.vendorForm.controls['serviceable_city_ids']).push(new FormControl(event.target.value));
      } else{
        var j:number = 0;
        (<FormArray>this.vendorForm.controls['serviceable_city_ids']).controls.forEach((ctr: FormControl) => {
          if(ctr.value == event.target.value) {
            // Remove the unselected element from the arrayForm
            (<FormArray>this.vendorForm.controls['serviceable_city_ids']).removeAt(j);
            return;
          }

          j++;
        });
      }
    }

    arrow_check = 'up';
    vendor_det;
    getVendorDetails(value){
      this.city_name = [];
      this.categoryService.getVendorDetails(value).subscribe(
        res=>{
           this.vendor_det =res['vendor']
            for(let city of res.vendor.serviceable_cities){
            let city_obj:any = {};
            // var obj = { "id": city.id, "itemName": city.name }
            city_obj['id'] = city.id;
            city_obj['itemName'] = city.name;
            
            this.city_name.push(city_obj);
          }
        },
        err=>{
          console.log(err);
        }
        );

    } 
    onVendorFormSubmit(){
     this.loaderService.display(true);
     this.categoryService.postVendorForm(this.vendorForm.value,this.basefile_pan,this.basefile_gst,this.basefile_cheque).subscribe(
       res=>{
         $('#addVendorModal').modal('hide'); 
         this.loaderService.display(false);
         this.successalert = true;
         this.successMessage = " Vendor Added successfully";
         setTimeout(function() {
            this.successalert = false;
         }.bind(this), 2000);
         this.selectedSet = 'first';
         window.location.reload(true);
         this.getVendorList();
       },
       err=>{
        console.log(err);
        $('#addVendorModal').modal('hide'); 
        this.erroralert = true;
        this.errorMessage = <any>JSON.parse(err['_body'])["message"];
        setTimeout(function() {
          this.erroralert = false;
         }.bind(this), 5000);
        this.loaderService.display(false);
       });
    }
    confirmAndDelete(id: number){
      if(confirm("Are You Sure You Want To delete?") == true){
        this.loaderService.display(true);
        this.deleteVendor(id);

      }

    }
    search_value: any;
    onKey(event: any) { // without type info
      this.search_value = event.target.value ;
      var  i=0;
      if(true){
        this.getVendorList('',this.search_value);
        i++;
      }
    }  

    private deleteVendor(id: number){
   
        this.categoryService.deleteVendor(id).subscribe(

        res=>{
          alert("deleted successfully");
          this.loaderService.display(false);
          this.getVendorList();
          // this.getProposalList(this.project_id);
        },
        err=>{
          console.log(err);
          this.loaderService.display(false);
        });

    }
    vendor_Id;
    pan_image:any;
    vendor_details; 
    sub_cat = [];
    city_name = [];
    selected_cate_subcate_list_update = [];
    getVendorForUpdate(vendorId){
      this.selectedSet = 'first';
      this.vendor_Id = vendorId;
      this.selected_cate_subcate_list_update = [];
      this.vendorUpdateForm.setControl('sub_category_ids', new FormArray([]));
      this.categoryService.getVendorDetails(vendorId).subscribe(
        res=>{
          this.vendor_details =res['vendor']
          this.sub_cat = res['vendor']['vendor_sub_categories']
          this.vendorUpdateForm.controls['name'].setValue(res.vendor.name);
          this.vendorUpdateForm.controls['address'].setValue(res.vendor.address);
          this.vendorUpdateForm.controls['pan_no'].setValue(res.vendor.pan_no);
          this.vendorUpdateForm.controls['contact_person'].setValue(res.vendor.contact_person);
          this.vendorUpdateForm.controls['contact_number'].setValue(res.vendor.contact_number);
          this.vendorUpdateForm.controls['email'].setValue(res.vendor.email);
          this.vendorUpdateForm.controls['gst_reg_no'].setValue(res.vendor.gst_reg_no);
          this.vendorUpdateForm.controls['account_holder'].setValue(res.vendor.account_holder);
          this.vendorUpdateForm.controls['account_number'].setValue(res.vendor.account_number);
          this.vendorUpdateForm.controls['bank_name'].setValue(res.vendor.bank_name);
          this.vendorUpdateForm.controls['branch_name'].setValue(res.vendor.branch_name);
          this.vendorUpdateForm.controls['ifsc_code'].setValue(res.vendor.ifsc_code);
          this.vendorUpdateForm.controls['contact_number'].setValue(res.vendor.contact_number);
          // this.vendorUpdateForm.controls['pan_copy'].setValue(res.vendor.pan_copy);
          // this.pan_image = res.vendor.pan_copy;
          // this.vendorUpdateForm.controls['cancelled_cheque'].setValue(res.vendor.cancelled_cheque);
          // this.vendorUpdateForm.controls['gst_copy'].setValue(res.vendor.gst_copy);
          this.vendorUpdateForm.controls['city'].setValue(res.vendor.city);
          // this.vendorUpdateForm.controls['category_ids'].setValue(res.vendor.category_ids);
          // this.vendorUpdateForm.controls['sub_category_ids'].setValue(res.vendor.sub_category_ids);
          for(let city of res.vendor.serviceable_cities){
            let city_obj:any = {};
            // var obj = { "id": city.id, "itemName": city.name }
            city_obj['id'] = city.id;
            city_obj['itemName'] = city.name;
            (<FormArray>this.vendorUpdateForm.controls['serviceable_city_ids']).push(new FormControl(city_obj));
            this.city_name.push(city.name);
          }

          for(let sub_cat of res.vendor.vendor_sub_categories){
            let cate_obj:any = [];
            cate_obj["category_id"]= sub_cat.parent_category_id;
            cate_obj['category_name'] = sub_cat.parent_category_name;
            cate_obj['subcategory_name'] = sub_cat.category_name;
            cate_obj['subcategory_id'] = sub_cat.id;
            this.selected_cate_subcate_list_update.push(cate_obj);
            (<FormArray>this.vendorUpdateForm.controls['sub_category_ids']).push(new FormControl(sub_cat.id));
          }

          this.vendorUpdateForm.controls['serviceable_city_ids'].setValue(res.vendor.serviceable_city_ids);
          if(res.vendor.vendor_sub_categories != null) {
          this.vendorUpdateForm.controls['vendor_sub_categories']['controls']=[];

          this.vendorUpdateForm.controls['scope_of_work'].setValue(res.vendor.vendor_sub_categories);
        }

          
        },
        err=>{
          console.log(err);
        });

    }
    onVendorUpdateFormSubmit(){
       this.loaderService.display(true);
      this.categoryService.postUpdateVendorForm(this.vendor_Id,this.vendorUpdateForm.value,this.basefile_pan,this.basefile_gst,this.basefile_cheque).subscribe(
       res=>{
         $('#vendorUpdateModal').modal('hide'); 
         this.loaderService.display(false);
         this.successalert = true;
         this.successMessage = " Vendor Updated successfully";
         setTimeout(function() {
            this.successalert = false;
         }.bind(this), 2000);
         this.selected_cate_subcate_list = [];
         this.getVendorList();
       },
       err=>{
          console.log(err);
          $('#vendorUpdateModal').modal('hide'); 
          this.erroralert = true;

          this.errorMessage = <any>JSON.parse(err['_body'])["message"];

          setTimeout(function() {
          this.erroralert = false;
         }.bind(this), 5000);
        this.loaderService.display(false);
       });

    }
    resetForm(){
      this.vendorForm.reset();
      this.selectedSet = 'first';
      this.selected_cate_subcate_list = [];

    }
    filterEvents(event){
      // this.loaderService.display(true);
      var value = event.target.value;
      if( value == 'all'){
        document.getElementById('cityId').setAttribute('style','display: inline-block');
        document.getElementById('categoryId').setAttribute('style','display: none');
        document.getElementById('SubcategoryId').setAttribute('style','display: none'); 
       this.getVendorList();

      }
      else{
        if( value == 'city'){
          document.getElementById('cityId').setAttribute('style','display: inline-block');
          document.getElementById('categoryId').setAttribute('style','display: none');
          document.getElementById('SubcategoryId').setAttribute('style','display: none');
        }
        else if( value == 'category'){
          document.getElementById('categoryId').setAttribute('style','display: inline-block');
          document.getElementById('cityId').setAttribute('style','display: none');
          document.getElementById('SubcategoryId').setAttribute('style','display: inline-block');
        }
        else{
          
          document.getElementById('categoryId').setAttribute('style','display: none');
          document.getElementById('cityId').setAttribute('style','display: none');
          document.getElementById('SubcategoryId').setAttribute('style','display: inline-block');

        }
        
      }
      
      


    }
    filterCities(event){
      this.loaderService.display(true);
      var value = event.target.value;
      if( value == 'all'){
        this.getVendorList();


      }
      else{
        this.categoryService.getCityListByFilterCities('city',value).subscribe(
          res=>{
           this.headers_res= res.headers._headers;
          this.per_page = this.headers_res.get('x-per-page');
          this.total_page = this.headers_res.get('x-total');
          this.current_page = this.headers_res.get('x-page');

          res= res.json();
           this.itemList = res['vendors'];
           this.loaderService.display(false);
          },
          err=>{
             console.log(err);
             this.loaderService.display(false);
          });

      }
      

    }
    filterCategories(event){
      this.loaderService.display(true);
      var value = event.target.value;
      if( value == 'all'){
        this.getVendorList();


      }
      else{
        this.categoryService.getCategoryListByStatus('category',value).subscribe(
          res=>{
          this.headers_res= res.headers._headers;
          this.per_page = this.headers_res.get('x-per-page');
          this.total_page = this.headers_res.get('x-total');
          this.current_page = this.headers_res.get('x-page');

          res= res.json();
           this.itemList = res['vendors'];
           this.getSubCategoriesValues(value);
           this.loaderService.display(false);
          },
          err=>{
             console.log(err);
             this.loaderService.display(false);
          });
      }
      

    }
    filterSubCategories(event){
      this.loaderService.display(true);
      var value = event.target.value;
      if( value == 'all'){
        this.getVendorList();

      }
      else{
        this.categoryService.getSubCategoryListByStatus('sub_category',value).subscribe(
          res=>{
           this.headers_res= res.headers._headers;
          this.per_page = this.headers_res.get('x-per-page');
          this.total_page = this.headers_res.get('x-total');
          this.current_page = this.headers_res.get('x-page');

          res= res.json();
           this.itemList = res['vendors'];
           this.loaderService.display(false);
          },
          err=>{
             console.log(err);
             this.loaderService.display(false);
          });
      }
      

    }
    filterPage(event){
      this.loaderService.display(true);
      var value = event.target.value;
      if( value == 'all'){
        this.getVendorList();

      }
      else{
        this.categoryService.getVendorPage(value).subscribe(
          res=>{
           
           this.itemList = res['vendors'];
           this.loaderService.display(false);
          },
          err=>{
             console.log(err);
             this.loaderService.display(false);
          });
      }
     
    }
    removeItem(value){
      for(var i=0;i<this.selected_cate_subcate_list.length; i++){
        var obj = this.selected_cate_subcate_list[i];
        if(obj.subcategory_id == value){
          this.selected_cate_subcate_list.splice(i, 1);
          var j:number = 0;

          (<FormArray>this.vendorForm.controls['sub_category_ids']).controls.forEach((ctr: FormControl) => {
            if(ctr.value == value) {
              // Remove the unselected element from the arrayForm
              (<FormArray>this.vendorForm.controls['sub_category_ids']).removeAt(j);
              return;
            }

            j++;
          });
        }

      }

    }
    removeUpdateItem(value){
      for(var i=0;i<this.selected_cate_subcate_list_update.length; i++){
        var obj = this.selected_cate_subcate_list_update[i];
        if(obj.subcategory_id == value){
          this.selected_cate_subcate_list_update.splice(i, 1);
          var j:number = 0;

          (<FormArray>this.vendorUpdateForm.controls['sub_category_ids']).controls.forEach((ctr: FormControl) => {
            if(ctr.value == value) {
              // Remove the unselected element from the arrayForm
              (<FormArray>this.vendorUpdateForm.controls['sub_category_ids']).removeAt(j);
              return;
            }

            j++;
          });
        }

      }

    }
  panInputChange(event){
    var value = event.target.value;
    var value2 = value.toUpperCase();
    $('#PanId').val(value2);
    for(var i =0 ; i<this.itemList.length;i++){
      var value1 = value.toUpperCase();
      if(this.itemList[i].pan_no == value1 ){
        alert("Pan Number Already exists");
        $('#PanId').val('');

      }
    }


  }  
  panInputUpdateChange(event){
    var value = event.target.value;
    var value2 = value.toUpperCase();
    $('#PanIdChng').val(value2);

    for(var i =0 ; i<this.itemList.length;i++){
      var value1 = value.toUpperCase();
      if(this.itemList[i].pan_no == value1 ){
        alert("Pan Number Already exists");
        $('#PanIdChng').val('');

      }
    }


  }

}




// WEBPACK FOOTER //
// /Users/shobhit/Documents/codes/arrivae-frontend/src/app/platform/category/category/vendor/vendor.component.ts